import { render, staticRenderFns } from "./eliminate-dialog.vue?vue&type=template&id=0672dc90&"
import script from "./eliminate-dialog.vue?vue&type=script&lang=js&"
export * from "./eliminate-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "eliminate-dialog.vue"
export default component.exports